<div class="nis_model">

    <!-- Action Buttons -->
    <div class="receipt-actions no-print">
        <button (click)="downloadPDF()" class="btn-pdf">Download PDF</button>
        <button (click)="printReceipt()" class="btn-print">Print</button>
        <button (click)="close()" class="btn-close-modal">Close</button>
    </div>

    <!-- Receipt Content -->
    <div #receiptContent class="receipt-body">

        <!-- Header -->
        <div class="receipt-header">
            <img src="assets/images/logo-nis.png" class="receipt-logo" alt="NIS Logo">
            <span class="receipt-title">E-VISA PAYMENT RECEIPT</span>
        </div>

        <!-- Application Details -->
        <div class="receipt-section-title">Application Details</div>
        <div class="receipt-table">
            <div class="receipt-row">
                <div class="receipt-cell">
                    <span class="cell-label">Applicant Name</span>
                    <span class="cell-value">{{paymentReceiptDetails.applicantName}}</span>
                </div>
                <div class="receipt-cell">
                    <span class="cell-label">Passport Type</span>
                    <span class="cell-value">{{paymentReceiptDetails.passportType}}</span>
                </div>
            </div>
            <div class="receipt-row">
                <div class="receipt-cell">
                    <span class="cell-label">Application Number</span>
                    <span class="cell-value">{{paymentReceiptDetails.applicationIdV1}}</span>
                </div>
                <div class="receipt-cell">
                    <span class="cell-label">Reference Number</span>
                    <span class="cell-value">{{paymentReceiptDetails.referenceIdV1}}</span>
                </div>
            </div>
            <div class="receipt-row">
                <div class="receipt-cell">
                    <span class="cell-label">Visa Class</span>
                    <span class="cell-value">{{paymentReceiptDetails.visaClass}}</span>
                </div>
                <div class="receipt-cell"></div>
            </div>
        </div>

        <!-- Payment Details -->
        <div class="receipt-section-title">Payment Details</div>
        <div class="receipt-table">
            <div class="receipt-row">
                <div class="receipt-cell">
                    <span class="cell-label">Order No.</span>
                    <span class="cell-value">{{paymentReceiptDetails.orderReference}}</span>
                </div>
                <div class="receipt-cell">
                    <span class="cell-label">Order Date (DD/MM/YYYY)</span>
                    <span class="cell-value">{{paymentReceiptDetails.orderDate}}</span>
                </div>
            </div>
            <div class="receipt-row">
                <div class="receipt-cell">
                    <span class="cell-label">Payment Gateway</span>
                    <span class="cell-value">{{paymentReceiptDetails.paymentGateway}}</span>
                </div>
                <div class="receipt-cell">
                    <span class="cell-label">Payment Mode</span>
                    <span class="cell-value">{{paymentReceiptDetails.paymentMode}}</span>
                </div>
            </div>
            <div class="receipt-row">
                <div class="receipt-cell">
                    <span class="cell-label">Payment Date (DD/MM/YYYY)</span>
                    <span class="cell-value">{{paymentReceiptDetails.paymentDate}}</span>
                </div>
                <div class="receipt-cell"></div>
            </div>
        </div>

        <!-- Application Fee Details -->
        <div class="receipt-section-title">Application Fee Details</div>

        <div *ngIf="paymentReceiptDetails.isGratis === constants.TRUE" class="gratis-banner">
            In view of the existing bilateral agreements/arrangements, your VISA is on gratis basis and no fee will be charged.
        </div>

        <div class="fee-table">
            <div class="fee-row">
                <span class="fee-label">Visa Fee</span>
                <span class="fee-value">{{paymentReceiptDetails.currencySymbol}}{{paymentReceiptDetails.visaFee | number: '1.2' : 'en-US'}}</span>
            </div>
            <div class="fee-row" *ngIf="paymentReceiptDetails.addOnfee > 0">
                <span class="fee-label">Biometric Fee</span>
                <span class="fee-value">{{paymentReceiptDetails.currencySymbol}}{{paymentReceiptDetails.addOnfee | number: '1.2' : 'en-US'}}</span>
            </div>
            <div class="fee-row" *ngIf="paymentReceiptDetails.serviceCharge > 0">
                <span class="fee-label">Transaction Fee</span>
                <span class="fee-value">{{paymentReceiptDetails.currencySymbol}}{{paymentReceiptDetails.serviceCharge | number: '1.2' : 'en-US'}}</span>
            </div>
            <div class="fee-row fee-total">
                <span class="fee-label">Total Fee</span>
                <span class="fee-value">{{paymentReceiptDetails.currencySymbol}}{{paymentReceiptDetails.totalFee | number: '1.2' : 'en-US'}}</span>
            </div>
        </div>

        <!-- Footer Note -->
        <div class="receipt-note">
            This is a computer generated bill. No signature/stamp is required.
        </div>

        <div class="receipt-footer-content" *ngIf="paymentReceiptDetails.footerContent">
            {{paymentReceiptDetails.footerContent}}
        </div>

    </div>
</div>
